import { MessageCircle } from 'lucide-react';

const PHONE = '523314566426';
const MESSAGE = encodeURIComponent('Hola! quiero mas informacion por favor.');
const WA_URL = `https://wa.me/${PHONE}?text=${MESSAGE}`;

export const WhatsAppButton = () => {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed right-6 z-40 bottom-24 lg:bottom-6 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg hover:shadow-xl transition-all hover:scale-110"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
};
